import { ImmutableMap } from '@/lib/immutable/ImmutableMap'
import { IAction } from '@/redux/actions/action-helpers'
import { CarRatesTypes } from '@/redux/actions/actions.types'
import { ApplicationState } from '@/redux/stores/types'
import { CarResult } from '@/travelsuit'
import { CarRate } from '@/travelsuit/cars.type'

type CarRatesState = ApplicationState['carRates']
export const emptyCarRatesState: CarRatesState = new ImmutableMap()

export function carRatesReducer(state: CarRatesState = emptyCarRatesState, action: IAction): CarRatesState {
	let carResult: CarResult
	let carRate: CarRate

	switch (action.type) {
		case CarRatesTypes.GetCarRates.SUCCESS:
			carResult = action.requestPayload
			carRate = action.payload
			return state.set(carResult.res_id, carRate)
	}
	return state
}

export default carRatesReducer
